import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export default class AuthService {
  static singup(data: any) {
    return fetch(`${apiUrl}/api/user/`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    }).then((data) => data.json());

    // return axios.post(`${apiUrl}/api/user`, data, {
    //     headers: {

    //         'Content-Type': 'application/json' ,
    //     }

    // } ).then(response => response.data)
  }

  static login(credentials: any) {
    return axios
      .post(`${apiUrl}/api/auth/login/`, credentials, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);
    //  return fetch(`${apiUrl}/api/auth/login/`, {

    //      headers: {
    //        'Accept': 'application/json',
    //        'Content-Type': 'application/json' ,
    //      },
    //      method: 'POST',
    //      body: JSON.stringify(credentials)
    //  }).then(data => data.json())
  }

  static active(token: string) {
    return axios
      .get(`${apiUrl}/api/user/active/${token}`, {})
      .then((response) => response.data);
  }

  static handleError(error: Error): void {
    console.error(error);
  }
}
